import React from 'react';

const FacetPlusIcon = () => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.77344 4V11M4.27344 7.5H11.2734M7.77344 14.5C3.90744 14.5 0.773438 11.366 0.773438 7.5C0.773438 3.63401 3.90744 0.5 7.77344 0.5C11.6394 0.5 14.7734 3.63401 14.7734 7.5C14.7734 11.366 11.6394 14.5 7.77344 14.5Z"
        stroke={'#7A8591'}
      />
    </svg>
  );
};

export default FacetPlusIcon;
